import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

// get local storage data
const getLocalStorageData = (key) => {
  const data = localStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
  return null;
};

// check if user is logged in
const isLoggedIn = () => {
  const user = getLocalStorageData("user");
  if (user) {
    return true;
  }
  return false;
};

//

const routes = [
  // admin  section

  {
    path: "/admin/login",
    name: "login",
    component: () =>
      import(
        /* webpackChunkName : "admin-login" */ "../views/admin/AdminLogin.vue"
      ),
  },

  // {
  //   path: "/admin/dashboard",
  //   name: "dashboard",
  //   component: () => import("../views/admin/DashboardPage.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (isLoggedIn()) {
  //       next();
  //     } else {
  //       next("/admin/login");
  //     }
  //   },
  // },

  // {
  //   path: "/admin/create-a-page-content",
  //   name: "create-a-page-content",
  //   component: () => import("../views/admin/CreateApageContent.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (isLoggedIn()) {
  //       next();
  //     } else {
  //       next("/admin/login");
  //     }
  //   },
  // },
  // {
  //   path: "/admin/all-page-contents",
  //   name: "all-page-contents",
  //   component: () => import("../views/admin/GetAllpageContents.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (isLoggedIn()) {
  //       next();
  //     } else {
  //       next("/admin/login");
  //     }
  //   },
  // },
  // {
  //   path: "/admin/update-page-content/:id",
  //   name: "update-page-content",
  //   component: () => import("../views/admin/UpdateApageContent.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (isLoggedIn()) {
  //       next();
  //     } else {
  //       next("/admin/login");
  //     }
  //   },
  // },
  // {
  //   path: "/admin/links",
  //   name: "all-links",
  //   component: () => import("../views/admin/AllLinks.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (isLoggedIn()) {
  //       next();
  //     } else {
  //       next("/admin/login");
  //     }
  //   },
  // },

  // website section

  // Home page
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName : "home" */ "../views/HomeView.vue"),
  },
  // sample page
  // {
  //   path: "/sample-page",
  //   name: "sample-page",
  //   component: () =>
  //     import(/* webpackChunkName : "samplepage" */ "../views/Sample-page.vue"),
  // },

  // color

  {
    path: "/color-picker",
    name: "color-picker",
    component: () =>
      import(
        /* webpackChunkName : "colorcodes" */ "../views/color/color-code.vue"
      ),
  },
  {
    path: "/rgb-to-hex",
    name: "rgb-to-hex",
    component: () =>
      import(
        /* webpackChunkName : "rgbtohex" */ "../views/color/Rgb-to-hex.vue"
      ),
  },
  {
    path: "/hex-to-rgb",
    name: "hex-to-rgb",
    component: () =>
      import(
        /* webpackChunkName : "hextorgb" */ "../views/color/Hex-to-rgb.vue"
      ),
  },
  // {
  //   path: "/hex-to-hsl",
  //   name: "hex-to-hsl",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "hextohsl" */ "../views/color/Hex-to-hsl.vue"
  //     ),
  // },
  // {
  //   path: "/color-wheel",
  //   name: "color-wheel",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "hextohsl" */ "../views/color/Color-Wheel.vue"
  //     ),
  // },

  // image section

  {
    path: "/image-compressor",
    name: "image-compressor",
    component: () =>
      import(
        /* webpackChunkName : "imagecompressor" */ "../views/img/Image-Compressor.vue"
      ),
  },

  {
    path: "/image-resizer",
    name: "image-resizer",
    component: () =>
      import(
        /* webpackChunkName : "imageresizer" */ "../views/img/ImageResizer.vue"
      ),
  },

  {
    path: "/png-converter",
    name: "png-converter",
    component: () =>
      import(
        /* webpackChunkName : "jpgtopngconverter" */ "../views/img/Png-Converter.vue"
      ),
  },
  // {
  //   path: "/jpg-converter",
  //   name: "jpg-converter",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "jpgtopngconverter" */ "../views/img/JpgConverter.vue"
  //     ),
  // },
  // {
  //   path: "/crop-image",
  //   name: "crop-image",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "image-crop" */ "../views/img/Image-Croper.vue"
  //     ),
  // },

  // {
  //   path: "/favicon-converter",
  //   name: "favicon-converter",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "favicon-converter" */ "../views/img/Favicon-Converter.vue"
  //     ),
  // },
  // {
  //   path: "/png-converter",
  //   name: "png-converter",
  //   component: () => import(/* webpackChunkName : "png-converter" */"../views/img/Png-Converter.vue"),
  // },

  // ip

  // {
  //   path: "/my-ip",
  //   name: "my-ip",
  //   component: () =>
  //     import(/* webpackChunkName : "my-ip" */ "../views/ip/My-Ip.vue"),
  // },
  // {
  //   path: "/ip-address-lookup",
  //   name: "ip-address-lookup",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "ip-deatils" */ "../views/ip/Ip-Details.vue"
  //     ),
  // },

  // domain
  // {
  //   path: "/whois-domain-lookup",
  //   name: "whois-domain-lookup",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "domain-deatils" */ "../views/domain/Domain-Details.vue"
  //     ),
  // },
  // {
  //   path: "/domain-to-ip",
  //   name: "domain-to-ip",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "domain-to-ip" */ "../views/domain/Domain-To-Ip.vue"
  //     ),
  // },

  // password
  // {
  //   path: "/password-strength-meter",
  //   name: "password-strength-meter",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "password-strength-meter" */ "../views/password/Password-strength-meter.vue"
  //     ),
  // },
  {
    path: "/password-generator",
    name: "password-generator",
    component: () =>
      import(
        /* webpackChunkName : "random-key-generator" */ "../views/password/Password-genetrator.vue"
      ),
  },
  {
    path: "/random-key-generator",
    name: "random-key-generator",
    component: () =>
      import(
        /* webpackChunkName : "random-key-generator" */ "../views/password/Random-string-generator"
      ),
  },

  // pfd section
  // {
  //   path: "/pdf-viewer",
  //   name: "pdf-viewer",
  //   component: () => import(/* webpackChunkName : "pdf-viewer" */"../views/pdf/Pdf-viewer.vue"),
  // },

  // text
  {
    path: "/text-transform",
    name: "text-transform",
    component: () =>
      import(
        /* webpackChunkName : "text-transform" */ "../views/text/Text-transform.vue"
      ),
  },
  {
    path: "/word-counter",
    name: "word-counter",
    component: () =>
      import(
        /* webpackChunkName : "word-counter" */ "../views/text/Word-counter.vue"
      ),
  },
  // {
  //   path: "/text-to-speech",
  //   name: "text-to-speech",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "text-to-speech" */ "../views/text/Text-to-speech.vue"
  //     ),
  // },
  // {
  //   path: "/speech-to-text",
  //   name: "speech-to-text",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "speech-to-text" */ "../views/text/Speech-to-text.vue"
  //     ),
  // },

  // {
  //   path: "/text-editor",
  //   name: "text-editor",
  //   component: () => import(/* webpackChunkName : "text-editor" */"../views/text/Text-editor.vue"),

  // },

  // Seo
  // {
  //   path: "/broken-link-checker",
  //   name: "broken-link-checker",
  //   component: () => import(/* webpackChunkName : "broken-link-checker" */"../views/seo/Broken-link-checker.vue"),
  // },

  // movies

  // {
  //   path: "/top-movies-and-series",
  //   name: "top-movies-and-series",
  //   component: () => import(/* webpackChunkName : "top-movies-and-series" */"../views/movies/Top-movies-and-series.vue"),
  // },

  // {
  //   path: "/movie-series-details/:id",
  //   name: "movie-series-details",
  //   component: () => import(/* webpackChunkName : "movie-series-details" */"../views/movies/Movie-series-details.vue"),
  // },

  // invoice section

  // {
  //   path: "/invoice-generator",
  //   name: "invoice-generator",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "invoice-generator" */ "../views/invoice/Invoice-Generator.vue"
  //     ),
  // },
  // clock

  {
    path: "/digital-clock",
    name: "digital-clock",
    component: () =>
      import(
        /* webpackChunkName : "digital-clock" */ "../views/time/DigitalClock.vue"
      ),
  },

  // {
  //   path: "/stopwatch",
  //   name: "stopwatch",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "stopwatch" */ "../views/time/StopWatch.vue"
  //     ),
  // },

  // {
  //   path: "/countdown-timer",
  //   name: "countdown-timer",
  //   component: () =>
  //     import(/* webpackChunkName : "timer" */ "../views/time/TimerWatch.vue"),
  // },

  // qr code section

  // {
  //   path: "/online-barcode-generator",
  //   name: "online-barcode-generator",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "barcode-generator" */ "../views/qrCode/BarCodeGenerator.vue"
  //     ),
  // },

  {
    path: "/online-qr-code-generator",
    name: "online-qr-code-generator",
    component: () =>
      import(
        /* webpackChunkName : "qr-code-generator" */ "../views/qrCode/QRcodeGenerator.vue"
      ),
  },

  // url
  // {
  //   path: "/url-shortener",
  //   name: "url-shortener",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "url-shortenerr" */ "../views/url/UrlSHortner.vue"
  //     ),
  // },

  // {
  //   path: "/url-encode-and-decode",
  //   name: "url-encode-and-decode",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "url-encoder" */ "../views/url/UrlEncoder.vue"
  //     ),
  // },

  // website
  // {
  //   path: "/html-viewer",
  //   name: "html-viewer",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "privacy-policy-generator" */ "../views/website/HtmlViewer.vue"
  //     ),
  // },

  // {
  //   path: "/privacy-policy-generator",
  //   name: "privacy-policy-generator",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "privacy-policy-generator" */ "../views/website/PrivacyPolicy.vue"
  //     ),
  // },
  // {
  //   path: "/trems-and-conditions-generator",
  //   name: "trems-and-conditions-generator",
  //   component: () =>
  //     import(
  //       /* webpackChunkName : "trems-and-conditions-generator" */ "../views/website/TermsAndCondition.vue"
  //     ),
  // },

  // expense 

    {
    path: "/expenses",
    name: "expenses",
    component: () =>
      import(
        /* webpackChunkName : "expenses" */ "../views/expense/Expense.vue"
      ),
      beforeEnter: (to, from, next) => {
        if (isLoggedIn()) {
          next();
        } else {
          next("/admin/login");
        }
      },
  },




  // website

  {
    path: "/about",
    name: "about",

    component: () =>
      import(/* webpackChunkName : "about" */ "../views/AboutView.vue"),
  },

  //terms and condition

  {
    path: "/terms-condition",
    name: "terms-condition",

    component: () =>
      import(
        /* webpackChunkName : "terms-condition" */ "../views/TermsConditions.vue"
      ),
  },

  //privacy policy
  {
    path: "/privacy-policy",
    name: "privacy-policy",

    component: () =>
      import(
        /* webpackChunkName : "password-strength-meter" */ "../views/PrivacyPolicy.vue"
      ),
  },

  // conatct us
  {
    path: "/contact-us",
    name: "contact-us",

    component: () =>
      import(/* webpackChunkName : "contact-us" */ "../views/ContactUs.vue"),
  },

  // not found page
  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName : "error" */ "../components/ErrorPage.vue"),
  },
  { path: "*", redirect: "/404" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // user Scroll contol
  scrollBehavior(to, form, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
